<template>
  <vs-popup title="안전위반통보서 등급 기준" :active.sync="isActive" class="grade-criteria-popup">
    <div class="grade-criteria">
      <div class="ribbon-grid">
        <div v-for="grade in grades" :key="`head-${grade.name}`" class="ribbon-head">
          <div class="ribbon-bar" :style="{ background: grade.barColor }"></div>
          <div class="ribbon-circle" :style="{ background: grade.barColor }">
            <div class="ribbon-circle-inner">
              <span class="grade-name" :style="{ color: grade.color }">{{ grade.name }}</span>
              <span class="grade-point" :style="{ color: grade.color }">({{ grade.point }})</span>
            </div>
          </div>
          <div class="ribbon-arrow" :style="{ borderTopColor: grade.arrowColor }"></div>
        </div>

        <div v-for="(grade, gradeIndex) in grades" :key="`body-${grade.name}`" class="ribbon-body" :class="{ divided: gradeIndex > 0 }">
          <ul>
            <li v-for="(item, itemIndex) in grade.items" :key="`${grade.name}-${itemIndex}`">
              <span class="check" :style="{ color: grade.color }">&#10003;</span>
              <!-- 항목 문자열은 컴포넌트 내부 상수라 v-html 사용 (밑줄/강조 표기용) -->
              <span class="item-text" v-html="item"></span>
            </li>
          </ul>
        </div>
      </div>

      <div class="notice-bar">※ 안전위반통보서의 발부권자<span class="highlight">(안전환경팀장)</span>의 판단하에 해당제도 운영 (전사 공통기준 적용)</div>
      <p class="notice-sub">※ 기본원칙 : 각 Case별 기준 해당 時 “구두경고(1차)” 실시 → (미조치 또는 불량) “안전위반통보서 발부”</p>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    isActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      grades: [
        {
          name: "경미",
          point: "-1점",
          color: "#3d85e0",
          barColor: "#9cc3f0",
          arrowColor: "#3d85e0",
          items: [
            "시정조치요청 관련 <b><u>미조치(방치)</u></b>",
            "안전지시 불이행",
            "기본수칙 위반 多 <b>(반복 위반)</b>",
            "안전기준 미준수로 인한 <b><u>물적 피해 야기</u></b>",
          ],
        },
        {
          name: "주의",
          point: "-2점",
          color: "#d99a2b",
          barColor: "#e7bc72",
          arrowColor: "#d99a2b",
          items: [
            "안전환경기준을 <b><u>고의적 위반</u></b>",
            "<b><u>안전지시 불이행 반복 발생</u></b>",
            "관공서 등 외부행정기관 점검 시 지적되어 <b><u>과태료 이상 부과</u></b>",
          ],
        },
        {
          name: "심각",
          point: "-3점",
          color: "#e05252",
          barColor: "#ec8b8b",
          arrowColor: "#e05252",
          items: [
            "해당 상황 (불안전한 행동·상태) 지속 時 <b><u>중대재해로 이어질 수 있는 상황 야기</u></b>",
            "기타 안전환경팀장 판단 時, 중대한 안전환경기준 위반에 해당하는 경우",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.grade-criteria-popup ::v-deep .vs-popup {
  width: 1000px;
  max-width: 95vw;
}
.grade-criteria {
  padding: 8px 4px 4px;
}
.ribbon-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.ribbon-head {
  position: relative;
  height: 158px;
}
.ribbon-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 34px;
  height: 16px;
}
.ribbon-circle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  width: 116px;
  height: 116px;
  border-radius: 50%;
  /* 색상 링 위에 떨어지는 안쪽 그림자 */
  box-shadow: inset 0 4px 4px rgba(0, 0, 0, 0.55);
  /* 흰색 원판의 그림자가 링 밖으로 번지지 않도록 클리핑 */
  overflow: hidden;
  z-index: 1;
}
.ribbon-circle-inner {
  /* 링 두께 = 가로 바 높이(16px) */
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  bottom: 16px;
  border-radius: 50%;
  background: #fff;
  /* 흰색 원판이 링 안쪽 아래로 떨어뜨리는 그림자 */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .grade-name {
    font-size: 26px;
    font-weight: 500;
    line-height: 1.2;
  }

  .grade-point {
    font-size: 15px;
    font-weight: 700;
  }
}
.ribbon-arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 6px;
  width: 0;
  height: 0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 13px solid;
}
.ribbon-body {
  padding: 14px 18px 18px;

  &.divided {
    border-left: 1px solid #e0e0e0;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      gap: 8px;
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 1.6;
      color: #333;
      word-break: keep-all;

      .check {
        font-weight: 700;
        flex-shrink: 0;
      }

      .item-text {
        /* 항목 문자열의 \n 을 줄바꿈으로 표시 */
        white-space: pre-line;
      }

      .item-text ::v-deep u,
      .item-text u {
        text-underline-offset: 2px;
      }
    }
  }
}
.notice-bar {
  margin-top: 10px;
  background: #2e3f54;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  padding: 12px 16px;
  word-break: keep-all;

  .highlight {
    color: #ffd43b;
  }
}
.notice-sub {
  margin: 12px 4px 0;
  font-size: 13px;
  font-weight: 600;
  color: #777;
  text-decoration: underline;
  word-break: keep-all;
}

@media (max-width: 768px) {
  .ribbon-grid {
    grid-template-columns: 1fr;
  }
  .ribbon-head {
    height: 140px;
  }
  .ribbon-body.divided {
    border-left: none;
    border-top: 1px solid #e0e0e0;
  }
}
</style>
